import MenuIcon from '@material-ui/icons/Menu';
import ExtensionIcon from '@material-ui/icons/Extension';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import {
  ApiIcon,
  BarChartIcon,
  CatalogIcon,
  CloudIcon,
  CreateIcon,
  DocsIcon,
  FileCheckIcon,
  GroupUsersIcon,
  HomeIcon,
  SearchIcon,
  TeamIcon,
  ToolsIcon,
} from '../../theme/svgs';
import { AuthorizedDevToolsSidebarItem } from '../../components/devtools';
import { externalToolsNavigation } from '../../theToolboxLinks/theToolboxConfig';
import { AiseMarketplaceSidebarSubmenuItem } from './AiseMarketplaceSidebarSubmenuItem';

// AppLayout already wraps nav + content in SidebarPage (padding, pin state).
// The nav slot must be only the Sidebar (drawer), not another SidebarPage,
// otherwise layout breaks (pin doesn't affect content) and submenus render under content.
const SidebarContent = () => (
  <Sidebar>
    <SidebarLogo />
    <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
      <SidebarSearchModal />
    </SidebarGroup>
    <SidebarDivider />
    <SidebarGroup label="Menu" icon={<MenuIcon />}>
      <SidebarItem icon={HomeIcon} to="/" text="Home" />
      <SidebarItem icon={CatalogIcon} to="catalog" text="Catalog" />
      <MyGroupsSidebarItem
        singularTitle="My Team"
        pluralTitle="My Teams"
        icon={TeamIcon}
        filter={{ 'spec.type': 'team' }}
      />
      <SidebarItem icon={ApiIcon} to="api-docs" text="APIs" />
      <SidebarItem icon={DocsIcon} to="docs" text="Docs" />
      <SidebarItem icon={CreateIcon} to="create" text="Create..." />
      <SidebarItem icon={FileCheckIcon} to="entity-validation" text="Validator" />
      <SidebarItem icon={CloudIcon} to="kube-self-serve" text="Kube Self Serve" />
      <SidebarItem icon={GroupUsersIcon} to="dtt-teamview" text="DTT TeamView" />
      <SidebarItem icon={FlashOnIcon} to="spark" text="Spark" />
      <SidebarItem icon={BarChartIcon} to="static-landscape" text="Landscape" />
      <SidebarItem icon={ExtensionIcon} text="AISE">
        <SidebarSubmenu title="AISE">
          <AiseMarketplaceSidebarSubmenuItem />
        </SidebarSubmenu>
      </SidebarItem>
      <SidebarItem icon={ToolsIcon} text="Toolbox">
        <SidebarSubmenu title="Toolbox">
          {externalToolsNavigation.map(category => (
            <SidebarSubmenuItem
              key={category.title}
              title={category.title}
              icon={category.icon}
              dropdownItems={category.children.map(child => ({
                title: child.title,
                to: child.to,
              }))}
            />
          ))}
        </SidebarSubmenu>
      </SidebarItem>
      <SidebarScrollWrapper>
        <AuthorizedDevToolsSidebarItem />
      </SidebarScrollWrapper>
    </SidebarGroup>
    <SidebarSpace />
    <SidebarDivider />
    <SidebarGroup
      label="Settings"
      icon={<UserSettingsSignInAvatar />}
      to="/settings"
    >
      <SidebarSettings />
    </SidebarGroup>
  </Sidebar>
);

export const SidebarContentExtension = NavContentBlueprint.make({
  params: {
    component: SidebarContent,
  },
});
